import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import {
  pastDateWithTodayValidation,
  // pastDateOnlyValidation,
  // futureDateWithTodayValidation,
} from "@validations/utils";

const SERVICES = FORM_FIELDS.EMPLOYEE.SERVICES;

export const SERVICE_HISTORY = SERVICES.SERVICE_HISTORY;
export const OTHER_SERVICES = SERVICES.OTHER_SERVICES;
export const PROMOTION_PARTICULARS = SERVICES.PROMOTION_PARTICULARS;

export const serviceHistoryServicesValidation = yup.object().shape({
  [SERVICE_HISTORY.ACC_SERVICE_DATE]: yup
    .string()
    .test("validator-service-date", pastDateWithTodayValidation)
    .required("ACC Service Date is required."),
  [SERVICE_HISTORY.GAZETTED_DATE]: yup.string(),
  // .test("validator-gazetted-date", pastDateWithTodayValidation)
  // .required("Gazetted Date is required.")
  [SERVICE_HISTORY.CONFIRMED_DATE]: yup.string(),
  // .test("validator-confirmed-date", pastDateWithTodayValidation)
  // .required("Confirmed Date is required.")
  [SERVICE_HISTORY.SENIORITY_DATE]: yup.string(),
  // .test("validator-seniority-date", pastDateWithTodayValidation)
  // .required("Seniority Date is required.")
});

export const otherServicesValidation = yup.object().shape({
  [OTHER_SERVICES.NAME_OF_EMPLOYER]: yup
    .string()
    .required("Employer Name is required."),
  [OTHER_SERVICES.ADDRESS]: yup.string().required("Address is required."),
  [OTHER_SERVICES.TYPE_OF_SERVICE]: yup
    .string()
    .required("Type of Service is required."),
  [OTHER_SERVICES.POSITION]: yup.string().required("Position is required."),
  [OTHER_SERVICES.FROM_DATE]: yup
    .string()
    // .test("validator-from-date", pastDateOnlyValidation)
    .required("From Date is required."),
  [OTHER_SERVICES.END_DATE]: yup
    .string()
    // .test("validator-to-date", futureDateWithTodayValidation)
    .required("To Date is required."),
  [OTHER_SERVICES.PAY_SCALE_FROM]: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .typeError("Pay Scale must have be a number"),
  [OTHER_SERVICES.PAY_SCALE_TO]: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .typeError("Pay Scale must have be a number"),
});

export const promotionParticularsServicesValidation = yup.object().shape({
  // [PROMOTION_PARTICULARS.RANK]: yup
  //   .number()
  //   .typeError("Grade Id is required")
  //   .required("Grade Id is required."),
  [PROMOTION_PARTICULARS.PROMOTION_DATE]: yup
    .string()
    // .test("validator-promotion-date", pastDateWithTodayValidation)
    .required("Promotion Date is required."),
  [PROMOTION_PARTICULARS.G_O_DATE]: yup
    .string()
    // .test("validator-go-date", pastDateWithTodayValidation)
    .required("G.O Date is required."),
  [PROMOTION_PARTICULARS.NATURE_OF_PROMOTION]: yup.string(),
  // .required("Nature of Promotion is required."),
  [PROMOTION_PARTICULARS.PAY_SCALE_FROM]: yup
    .number()
    .required("Pay Scale Min is required."),
  [PROMOTION_PARTICULARS.PAY_SCALE_TO]: yup
    .number()
    .required("Pay Scale Max is required."),
});

export interface FormData {
  servicesHistory: yup.InferType<typeof serviceHistoryServicesValidation>[];
  otherServices: yup.InferType<typeof otherServicesValidation>[];
  promotionParticulars: yup.InferType<
    typeof promotionParticularsServicesValidation
  >[];
}

export type ServiceHistoryFormDataType = yup.InferType<
  typeof serviceHistoryServicesValidation
>;
export type PromotionParticularsFormDataType = yup.InferType<
  typeof promotionParticularsServicesValidation
>;
export type OtherServicesFormDataType = yup.InferType<
  typeof otherServicesValidation
>;

export const formSchema = yup.object().shape({
  servicesHistory: yup.array().of(serviceHistoryServicesValidation),
  otherServices: yup.array().of(otherServicesValidation),
  promotionParticulars: yup.array().of(promotionParticularsServicesValidation),
});
